import { AvailableModules } from 'generated/featureDefinitions'
import { ModulesCrossSellingModule, ModulesDatoModule } from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { moduleIcons } from './moduleMappers'
import { CrossSellingModalState } from './useProductUpdatesHeader'

/**
 * Builds the cross selling object for the dropdown.
 */
export function BuildCrossSelling({
  moduleId,
  crossSellingModules,
  setCrossSellingModal,
  crossSellingVisible,
  setCrossSellingVisible,
  setViewUpsellProductCardComponent,
}: {
  moduleId: string | undefined
  crossSellingModules: (ModulesCrossSellingModule | ModulesDatoModule)[] | undefined
  setCrossSellingModal: (open: CrossSellingModalState) => void
  crossSellingVisible: boolean
  setCrossSellingVisible: (open: boolean) => void
  setViewUpsellProductCardComponent: (date: string) => void
}) {
  return {
    isVisible: crossSellingVisible,
    sectionTitle: i18n.t('product_updates.notification_widget.cross_selling_section_title'),
    onClose: () => {
      setViewUpsellProductCardComponent(new Date().toISOString())
      setCrossSellingVisible(false)
      track(trackingEvents.upsell.dismissProductUpsellComponent, {
        source: 'product_updates_dropdown',
        component: 'product_card',
        module: moduleId,
      })
    },
    products: (crossSellingModules ?? []).map((crossSellingModule) => ({
      title: crossSellingModule.name || '',
      description: crossSellingModule.shortDescription || '',
      onClick: () => {
        setCrossSellingModal({
          isOpen: true,
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          moduleRequested: crossSellingModule.chargebeeModuleName as AvailableModules,
        })
        track(trackingEvents.upsell.clickProductUpsellComponent, {
          source: 'product_updates_dropdown',
          module: crossSellingModule.chargebeeModuleName,
          component: 'product_card',
        })
      },
      dismissable: false,
      icon: moduleIcons(crossSellingModule.chargebeeModuleName || ''),
      trackVisibility: (open: boolean) => {
        if (open) {
          track(trackingEvents.upsell.viewProductUpsellComponent, {
            source: 'product_updates_dropdown',
            module: crossSellingModule.chargebeeModuleName,
            component: 'product_card',
          })
        }
      },
    })),
  }
}
